export default __webpack_public_path__ + "static/media/annie-spratt-qyAka7W5uMY-unsplash.8f0efaaa.jpg";